<!--
  加盟信息 - 业主加盟/区域战略合作
  add by lty
  date: 2019-12-27
 -->
<template>
  <div style="width:1628px;">
    <div>
      <span class="xbed-sub-title">{{title}}</span>
    </div>
    
    <div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>加盟信息</BreadcrumbItem>
				<BreadcrumbItem>{{title}}</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>

    <Form inline class="i-form">
      <FormItem label="省份" :label-width="60">
        <Select style="width:180px" v-model="province" clearable filterable label-in-value @on-change="changeProvice">
          <Option :value="-1">全部</Option>
          <Option v-for="item in provinceList" :key="item.id" :value="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="城市" :label-width="60">
        <Select ref="resetCity" style="width:180px" v-model="city" clearable filterable label-in-value @on-change="changeCity">
          <Option v-for="item in cityList" :key="item.id" :value="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="姓名" :label-width="60">
        <Input type="text" v-model.trim="queryParams.nameCn" clearable></Input>
      </FormItem>
      <FormItem label="手机号" :label-width="60">
        <Input type="text" v-model.trim="queryParams.phoneNo" clearable :maxlength="11"></Input>
      </FormItem><br/>
      <FormItem label="日期" :label-width="60">
        <DatePicker type="daterange" v-model="dateTime" clearable class="date-time" placeholder="请选择" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleBtn" style="margin-left: 32px; width: 60px;">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="exportReport">导出筛选结果</Button>
      </FormItem>
    </Form>
    <!-- Table-->
    <Content>
      <Table ref="noticeModal" stripe :loading="consumloading" :columns="columns" :data="joinListData" :style="{'width': areaJoin ? '1062px' : '1242px'}"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page 
          show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.pageNum" 
          :page-size="queryParams.pageSize"
          @on-page-size-change="changePageSize" 
          @on-change="changePage"
        >
        </Page>
      </div>
    </Content>
  </div>  
</template>

<script>
  /* eslint-disable */
  import Moment from "moment";
  import Utils from "@/utils";
  import API from "@/api";
  import Config from "@/config";
  export default {
    created() {
		  this.token = Utils.findFromLocalStorage( "vue-token" );
      this.env = Utils.findFromLocalStorage( "env", "dev" );
      this.areaJoin = false

      // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
      this.protHeaders = {
        'x-ca-stage': Utils.aliHeaderEnv(this.env), 
        'Authorization': Utils.findFromLocalStorage("Author-token")
      }
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
        this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
      }
      if (location.hash == '#/app/marketing/joinArea' || location.hash == '#/Market/Market/joinArea') {
        this.areaJoin = true
      }
    },

    data() {
      return {
        title: '业主加盟',
        consumloading: false,
        sureLoading: false,
        dateTime: [], // 日期
        dateType: '1',
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          type: 1, // 类型（1：业主加盟，2：清洁服务加盟，3：星创俱乐部,4区域战略合作）
          province: -1, // 省
          city: '', // 市
          nameCn: '', // 姓名
          phoneNo: '', // 手机号
          createDateBegin: '', // 创建时间开始
          createDateEnd: '', // 创建时间结束
        },
        province: -1,
        city: '',
        listCount: 0, // 分页
        joinListData: [],
        provinceList: [], // 所有省份
        cityList: [], // 所有城市
        columns: [
          {
            title: '序号',
            key: 'id',
            align: "center",
            width: 120
          },
          {
            title: '中文姓名',
            key: 'nameCn',
            align: "center",
            width: 150
          },
          {
            title: '手机号',
            key: 'phoneNo',
            align: "center",
            width: 180
          },
          {
            title: '省',
            key: 'province',
            align: "center",
            width: 180
          },
          {
            title: '市',
            key: 'city',
            align: "center",
            width: 180
          },
          {
            title: '时间',
            key: 'createDate',
            align: "center",
            width: 250
          }
        ],
      }
    },

    mounted() {
      this.$Notice.config({
        top: 150
      });
      if (this.areaJoin) {
        this.queryParams.type = 4
        this.title = '区域战略合作'
      } else {
        this.columns.splice(5, 0, {
          title: '区县',
          key: 'county',
          align: "center",
          width: 180
        })
      }
      this.getJoinList()
      this.getProvince()
    },

    methods: {
      // 获取公告列表数据
      async getJoinList() {
        this.consumloading = true

        let _queryParams = this.queryParams
        _queryParams.createDateBegin = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
        _queryParams.createDateEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
        // 过滤空字段
        _queryParams = Object.keys(_queryParams).reduce(function(c, k) {
          if (_queryParams[k] && _queryParams[k] != -1 ) {
            c[k] = _queryParams[k]
          }
          return c
        }, {})

        try {
          const resp = (await API.omsAPI[this.env].clientServer.getJoinInfoList(_queryParams, this.protHeaders)).data;
          this.consumloading = false
          if ( resp.retCode ) {
            this.$Notice.error( {
              title: resp.msg,
              desc: '获取加盟列表数据异常'
            })
            return
          }
          this.joinListData = resp.list || []
          this.listCount = resp.total
        } catch(e) {
          this.consumloading = false
        }
      },
      // 查询按钮
      handleBtn() {
        this.queryParams.pageNum = 1
        this.getJoinList()
      },

      // 获取全部省份 && 全部城市
      async getProvince() {
        let resp = (await API.omsAPI[this.env].marketing.getDistrictByPid( { id: 100000}, this.token )).data
        if ( resp.retCode ) {
          this.$Notice.error( {
            title: resp.msg,
            desc: '获取数据异常'
          })
          return
        }
        this.provinceList = resp.cityDtoList
      },

      // 选择省份并获取对应城市
      async changeProvice (options) {
        this.cityList = []
        this.$refs.resetCity.clearSingleSelect()
        this.queryParams.province = ''
        if (!options || options.value == -1) return
        this.queryParams.province = options.label
        let resp = (await API.omsAPI[this.env].marketing.getDistrictByPid({id: options.value}, this.token )).data
        if ( resp.retCode ) {
          this.$Notice.error( {
            title: resp.msg,
            desc: '获取数据异常'
          })
          return
        }
        this.cityList = resp.cityDtoList
      },

      changeCity (options) {
        this.queryParams.city = ''
        if (!options) return
        this.queryParams.city = options.label
      },

      // 分页
      changePageSize(pageSize) {
        this.queryParams.pageNum = 1
        this.queryParams.pageSize = pageSize
        this.getJoinList()
      },
      changePage(pageIndex) {
        this.queryParams.pageNum = pageIndex
        this.getJoinList()
      },

      // 导出结果
      exportReport(){
        if (!this.joinListData.length) {
          this.$Notice.warning( {
            title: "无数据符合当前筛选条件，请调整"
          } );
          return
        }

        let _queryParams = this.queryParams
        _queryParams.createDateBegin = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
        _queryParams.createDateEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
        // 过滤空字段并拼接参数
        const initParam = params => {
          let paramStr = '';
          Object.keys( params ).forEach( item => {
            if ( params[item] && params[item] != -1 ) {
              paramStr += item + '=' + params[item] + '&';
            }
          } )
          return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
        }
        let paramsInfos = initParam(_queryParams);

        let url = `${ Config[this.env].analysisUrl }excel/exportJoinInfoRecord?${ paramsInfos }`;
        Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, 'exportLoading' )
      }
    }
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/marketing/join.vue